import React, { RefObject } from 'react';
import { envIsCanada } from '@/constants/constants';
import OntarioRegistration from '@/features/modal/modals/register/ontario/OntarioRegistration';

const RegisterManagerModal = ({
  closeModal,
  modalWrapperRef,
}: {
  closeModal: () => void;
  modalWrapperRef: RefObject<HTMLDivElement>;
}) => {
  if (envIsCanada()) {
    return <OntarioRegistration closeModal={closeModal} modalWrapperRef={modalWrapperRef} />;
  }

  // TODO: add register form for Normal build
  return null;
};

export default RegisterManagerModal;
